import {
  calculateVariation,
  calculateVariationDirection,
  type BoxDashboardKpiEntity,
  type VariationDirection,
} from "@/modules/boxDashboard/modules/KPI/entities/boxDashboardKpiEntity"

export type TrialsCountModel = {
  count: number
  comparisonCount: number | null
  variationDirection: VariationDirection | null
}

export type ConversionRateModel = {
  rate: number
  comparisonRate: number | null
  variationPoints: number | null
  variationDirection: VariationDirection | null
}

export type TrialsKpiModel = {
  trials: TrialsCountModel
  conversionRate: ConversionRateModel
}

export function createEmptyTrialsKpiModel(): TrialsKpiModel {
  return {
    trials: {
      count: 0,
      comparisonCount: null,
      variationDirection: null,
    },
    conversionRate: {
      rate: 0,
      comparisonRate: null,
      variationPoints: null,
      variationDirection: null,
    },
  }
}

export function createTrialsKpiModel(entity: BoxDashboardKpiEntity): TrialsKpiModel {
  const trialsCountFocus = entity.trials.count.baseline
  const trialsCountComparison = entity.trials.count.comparison

  const conversionRateFocus = entity.trials.conversionRate.baseline
  const conversionRateComparison = entity.trials.conversionRate.comparison

  return {
    trials: {
      count: trialsCountFocus,
      comparisonCount: calculateVariation(trialsCountFocus, trialsCountComparison),
      variationDirection: calculateVariationDirection(trialsCountFocus, trialsCountComparison),
    },
    conversionRate: {
      rate: conversionRateFocus,
      comparisonRate: conversionRateComparison,
      variationPoints: calculateVariation(conversionRateFocus, conversionRateComparison),
      variationDirection: calculateVariationDirection(conversionRateFocus, conversionRateComparison),
    },
  }
}
